/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppUnauthorizedRouteImport } from './routes/_app/unauthorized'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppOrganizationRouteImport } from './routes/_app/organization'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks.index'
import { Route as AppPlatformIndexRouteImport } from './routes/_app/platform/index'
import { Route as AppOrganizationIndexRouteImport } from './routes/_app/organization/index'
import { Route as AppLawIndexRouteImport } from './routes/_app/law/index'
import { Route as AppTasksTaskUuidRouteImport } from './routes/_app/tasks.$taskUuid'
import { Route as AppPlatformAccountRouteImport } from './routes/_app/platform/account'
import { Route as AppOrganizationVaultRouteImport } from './routes/_app/organization/vault'
import { Route as AppOrganizationUsersRouteImport } from './routes/_app/organization/users'
import { Route as AppOrganizationTaxonomyRouteImport } from './routes/_app/organization/taxonomy'
import { Route as AppOrganizationReportsRouteImport } from './routes/_app/organization/reports'
import { Route as AppOrganizationPromptsRouteImport } from './routes/_app/organization/prompts'
import { Route as AppOrganizationOverviewRouteImport } from './routes/_app/organization/overview'
import { Route as AppOrganizationCustomDashboardsRouteImport } from './routes/_app/organization/custom-dashboards'
import { Route as AppOrganizationAdminRouteImport } from './routes/_app/organization/admin'
import { Route as AppLawVaultRouteImport } from './routes/_app/law/vault'
import { Route as AppOrganizationAdminIndexRouteImport } from './routes/_app/organization/admin/index'
import { Route as AppLawVaultIndexRouteImport } from './routes/_app/law/vault.index'
import { Route as AppOrganizationAdminVersionsRouteImport } from './routes/_app/organization/admin/versions'
import { Route as AppOrganizationAdminTaxonomyRouteImport } from './routes/_app/organization/admin/taxonomy'
import { Route as AppOrganizationAdminRunsRouteImport } from './routes/_app/organization/admin/runs'
import { Route as AppOrganizationAdminRiskRouteImport } from './routes/_app/organization/admin/risk'
import { Route as AppOrganizationAdminPromptsRouteImport } from './routes/_app/organization/admin/prompts'
import { Route as AppOrganizationAdminAccessRouteImport } from './routes/_app/organization/admin/access'
import { Route as AppLawVaultTasksRouteImport } from './routes/_app/law/vault.tasks'
import { Route as AppLawVaultFamilyFamilyIdRouteImport } from './routes/_app/law/vault.family.$familyId'
import { Route as AppLawVaultAnalysisContractIdRouteImport } from './routes/_app/law/vault.analysis.$contractId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUnauthorizedRoute = AppUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationRoute = AppOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationIndexRoute = AppOrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppLawIndexRoute = AppLawIndexRouteImport.update({
  id: '/law/',
  path: '/law/',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksTaskUuidRoute = AppTasksTaskUuidRouteImport.update({
  id: '/$taskUuid',
  path: '/$taskUuid',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppPlatformAccountRoute = AppPlatformAccountRouteImport.update({
  id: '/platform/account',
  path: '/platform/account',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationVaultRoute = AppOrganizationVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationUsersRoute = AppOrganizationUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationTaxonomyRoute = AppOrganizationTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationReportsRoute = AppOrganizationReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationPromptsRoute = AppOrganizationPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationOverviewRoute = AppOrganizationOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppOrganizationCustomDashboardsRoute =
  AppOrganizationCustomDashboardsRouteImport.update({
    id: '/custom-dashboards',
    path: '/custom-dashboards',
    getParentRoute: () => AppOrganizationRoute,
  } as any)
const AppOrganizationAdminRoute = AppOrganizationAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppOrganizationRoute,
} as any)
const AppLawVaultRoute = AppLawVaultRouteImport.update({
  id: '/law/vault',
  path: '/law/vault',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationAdminIndexRoute =
  AppOrganizationAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppLawVaultIndexRoute = AppLawVaultIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLawVaultRoute,
} as any)
const AppOrganizationAdminVersionsRoute =
  AppOrganizationAdminVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppOrganizationAdminTaxonomyRoute =
  AppOrganizationAdminTaxonomyRouteImport.update({
    id: '/taxonomy',
    path: '/taxonomy',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppOrganizationAdminRunsRoute =
  AppOrganizationAdminRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppOrganizationAdminRiskRoute =
  AppOrganizationAdminRiskRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppOrganizationAdminPromptsRoute =
  AppOrganizationAdminPromptsRouteImport.update({
    id: '/prompts',
    path: '/prompts',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppOrganizationAdminAccessRoute =
  AppOrganizationAdminAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AppOrganizationAdminRoute,
  } as any)
const AppLawVaultTasksRoute = AppLawVaultTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppLawVaultRoute,
} as any)
const AppLawVaultFamilyFamilyIdRoute =
  AppLawVaultFamilyFamilyIdRouteImport.update({
    id: '/family/$familyId',
    path: '/family/$familyId',
    getParentRoute: () => AppLawVaultRoute,
  } as any)
const AppLawVaultAnalysisContractIdRoute =
  AppLawVaultAnalysisContractIdRouteImport.update({
    id: '/analysis/$contractId',
    path: '/analysis/$contractId',
    getParentRoute: () => AppLawVaultRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/organization': typeof AppOrganizationRouteWithChildren
  '/tasks': typeof AppTasksRouteWithChildren
  '/unauthorized': typeof AppUnauthorizedRoute
  '/law/vault': typeof AppLawVaultRouteWithChildren
  '/organization/admin': typeof AppOrganizationAdminRouteWithChildren
  '/organization/custom-dashboards': typeof AppOrganizationCustomDashboardsRoute
  '/organization/overview': typeof AppOrganizationOverviewRoute
  '/organization/prompts': typeof AppOrganizationPromptsRoute
  '/organization/reports': typeof AppOrganizationReportsRoute
  '/organization/taxonomy': typeof AppOrganizationTaxonomyRoute
  '/organization/users': typeof AppOrganizationUsersRoute
  '/organization/vault': typeof AppOrganizationVaultRoute
  '/platform/account': typeof AppPlatformAccountRoute
  '/tasks/$taskUuid': typeof AppTasksTaskUuidRoute
  '/law/': typeof AppLawIndexRoute
  '/organization/': typeof AppOrganizationIndexRoute
  '/platform/': typeof AppPlatformIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/law/vault/tasks': typeof AppLawVaultTasksRoute
  '/organization/admin/access': typeof AppOrganizationAdminAccessRoute
  '/organization/admin/prompts': typeof AppOrganizationAdminPromptsRoute
  '/organization/admin/risk': typeof AppOrganizationAdminRiskRoute
  '/organization/admin/runs': typeof AppOrganizationAdminRunsRoute
  '/organization/admin/taxonomy': typeof AppOrganizationAdminTaxonomyRoute
  '/organization/admin/versions': typeof AppOrganizationAdminVersionsRoute
  '/law/vault/': typeof AppLawVaultIndexRoute
  '/organization/admin/': typeof AppOrganizationAdminIndexRoute
  '/law/vault/analysis/$contractId': typeof AppLawVaultAnalysisContractIdRoute
  '/law/vault/family/$familyId': typeof AppLawVaultFamilyFamilyIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unauthorized': typeof AppUnauthorizedRoute
  '/organization/custom-dashboards': typeof AppOrganizationCustomDashboardsRoute
  '/organization/overview': typeof AppOrganizationOverviewRoute
  '/organization/prompts': typeof AppOrganizationPromptsRoute
  '/organization/reports': typeof AppOrganizationReportsRoute
  '/organization/taxonomy': typeof AppOrganizationTaxonomyRoute
  '/organization/users': typeof AppOrganizationUsersRoute
  '/organization/vault': typeof AppOrganizationVaultRoute
  '/platform/account': typeof AppPlatformAccountRoute
  '/tasks/$taskUuid': typeof AppTasksTaskUuidRoute
  '/law': typeof AppLawIndexRoute
  '/organization': typeof AppOrganizationIndexRoute
  '/platform': typeof AppPlatformIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/law/vault/tasks': typeof AppLawVaultTasksRoute
  '/organization/admin/access': typeof AppOrganizationAdminAccessRoute
  '/organization/admin/prompts': typeof AppOrganizationAdminPromptsRoute
  '/organization/admin/risk': typeof AppOrganizationAdminRiskRoute
  '/organization/admin/runs': typeof AppOrganizationAdminRunsRoute
  '/organization/admin/taxonomy': typeof AppOrganizationAdminTaxonomyRoute
  '/organization/admin/versions': typeof AppOrganizationAdminVersionsRoute
  '/law/vault': typeof AppLawVaultIndexRoute
  '/organization/admin': typeof AppOrganizationAdminIndexRoute
  '/law/vault/analysis/$contractId': typeof AppLawVaultAnalysisContractIdRoute
  '/law/vault/family/$familyId': typeof AppLawVaultFamilyFamilyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/organization': typeof AppOrganizationRouteWithChildren
  '/_app/tasks': typeof AppTasksRouteWithChildren
  '/_app/unauthorized': typeof AppUnauthorizedRoute
  '/_app/law/vault': typeof AppLawVaultRouteWithChildren
  '/_app/organization/admin': typeof AppOrganizationAdminRouteWithChildren
  '/_app/organization/custom-dashboards': typeof AppOrganizationCustomDashboardsRoute
  '/_app/organization/overview': typeof AppOrganizationOverviewRoute
  '/_app/organization/prompts': typeof AppOrganizationPromptsRoute
  '/_app/organization/reports': typeof AppOrganizationReportsRoute
  '/_app/organization/taxonomy': typeof AppOrganizationTaxonomyRoute
  '/_app/organization/users': typeof AppOrganizationUsersRoute
  '/_app/organization/vault': typeof AppOrganizationVaultRoute
  '/_app/platform/account': typeof AppPlatformAccountRoute
  '/_app/tasks/$taskUuid': typeof AppTasksTaskUuidRoute
  '/_app/law/': typeof AppLawIndexRoute
  '/_app/organization/': typeof AppOrganizationIndexRoute
  '/_app/platform/': typeof AppPlatformIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/law/vault/tasks': typeof AppLawVaultTasksRoute
  '/_app/organization/admin/access': typeof AppOrganizationAdminAccessRoute
  '/_app/organization/admin/prompts': typeof AppOrganizationAdminPromptsRoute
  '/_app/organization/admin/risk': typeof AppOrganizationAdminRiskRoute
  '/_app/organization/admin/runs': typeof AppOrganizationAdminRunsRoute
  '/_app/organization/admin/taxonomy': typeof AppOrganizationAdminTaxonomyRoute
  '/_app/organization/admin/versions': typeof AppOrganizationAdminVersionsRoute
  '/_app/law/vault/': typeof AppLawVaultIndexRoute
  '/_app/organization/admin/': typeof AppOrganizationAdminIndexRoute
  '/_app/law/vault/analysis/$contractId': typeof AppLawVaultAnalysisContractIdRoute
  '/_app/law/vault/family/$familyId': typeof AppLawVaultFamilyFamilyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/organization'
    | '/tasks'
    | '/unauthorized'
    | '/law/vault'
    | '/organization/admin'
    | '/organization/custom-dashboards'
    | '/organization/overview'
    | '/organization/prompts'
    | '/organization/reports'
    | '/organization/taxonomy'
    | '/organization/users'
    | '/organization/vault'
    | '/platform/account'
    | '/tasks/$taskUuid'
    | '/law/'
    | '/organization/'
    | '/platform/'
    | '/tasks/'
    | '/law/vault/tasks'
    | '/organization/admin/access'
    | '/organization/admin/prompts'
    | '/organization/admin/risk'
    | '/organization/admin/runs'
    | '/organization/admin/taxonomy'
    | '/organization/admin/versions'
    | '/law/vault/'
    | '/organization/admin/'
    | '/law/vault/analysis/$contractId'
    | '/law/vault/family/$familyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unauthorized'
    | '/organization/custom-dashboards'
    | '/organization/overview'
    | '/organization/prompts'
    | '/organization/reports'
    | '/organization/taxonomy'
    | '/organization/users'
    | '/organization/vault'
    | '/platform/account'
    | '/tasks/$taskUuid'
    | '/law'
    | '/organization'
    | '/platform'
    | '/tasks'
    | '/law/vault/tasks'
    | '/organization/admin/access'
    | '/organization/admin/prompts'
    | '/organization/admin/risk'
    | '/organization/admin/runs'
    | '/organization/admin/taxonomy'
    | '/organization/admin/versions'
    | '/law/vault'
    | '/organization/admin'
    | '/law/vault/analysis/$contractId'
    | '/law/vault/family/$familyId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/organization'
    | '/_app/tasks'
    | '/_app/unauthorized'
    | '/_app/law/vault'
    | '/_app/organization/admin'
    | '/_app/organization/custom-dashboards'
    | '/_app/organization/overview'
    | '/_app/organization/prompts'
    | '/_app/organization/reports'
    | '/_app/organization/taxonomy'
    | '/_app/organization/users'
    | '/_app/organization/vault'
    | '/_app/platform/account'
    | '/_app/tasks/$taskUuid'
    | '/_app/law/'
    | '/_app/organization/'
    | '/_app/platform/'
    | '/_app/tasks/'
    | '/_app/law/vault/tasks'
    | '/_app/organization/admin/access'
    | '/_app/organization/admin/prompts'
    | '/_app/organization/admin/risk'
    | '/_app/organization/admin/runs'
    | '/_app/organization/admin/taxonomy'
    | '/_app/organization/admin/versions'
    | '/_app/law/vault/'
    | '/_app/organization/admin/'
    | '/_app/law/vault/analysis/$contractId'
    | '/_app/law/vault/family/$familyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/unauthorized': {
      id: '/_app/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AppUnauthorizedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/platform/': {
      id: '/_app/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/': {
      id: '/_app/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AppOrganizationIndexRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/law/': {
      id: '/_app/law/'
      path: '/law'
      fullPath: '/law/'
      preLoaderRoute: typeof AppLawIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/$taskUuid': {
      id: '/_app/tasks/$taskUuid'
      path: '/$taskUuid'
      fullPath: '/tasks/$taskUuid'
      preLoaderRoute: typeof AppTasksTaskUuidRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/platform/account': {
      id: '/_app/platform/account'
      path: '/platform/account'
      fullPath: '/platform/account'
      preLoaderRoute: typeof AppPlatformAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/vault': {
      id: '/_app/organization/vault'
      path: '/vault'
      fullPath: '/organization/vault'
      preLoaderRoute: typeof AppOrganizationVaultRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/users': {
      id: '/_app/organization/users'
      path: '/users'
      fullPath: '/organization/users'
      preLoaderRoute: typeof AppOrganizationUsersRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/taxonomy': {
      id: '/_app/organization/taxonomy'
      path: '/taxonomy'
      fullPath: '/organization/taxonomy'
      preLoaderRoute: typeof AppOrganizationTaxonomyRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/reports': {
      id: '/_app/organization/reports'
      path: '/reports'
      fullPath: '/organization/reports'
      preLoaderRoute: typeof AppOrganizationReportsRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/prompts': {
      id: '/_app/organization/prompts'
      path: '/prompts'
      fullPath: '/organization/prompts'
      preLoaderRoute: typeof AppOrganizationPromptsRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/overview': {
      id: '/_app/organization/overview'
      path: '/overview'
      fullPath: '/organization/overview'
      preLoaderRoute: typeof AppOrganizationOverviewRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/custom-dashboards': {
      id: '/_app/organization/custom-dashboards'
      path: '/custom-dashboards'
      fullPath: '/organization/custom-dashboards'
      preLoaderRoute: typeof AppOrganizationCustomDashboardsRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/organization/admin': {
      id: '/_app/organization/admin'
      path: '/admin'
      fullPath: '/organization/admin'
      preLoaderRoute: typeof AppOrganizationAdminRouteImport
      parentRoute: typeof AppOrganizationRoute
    }
    '/_app/law/vault': {
      id: '/_app/law/vault'
      path: '/law/vault'
      fullPath: '/law/vault'
      preLoaderRoute: typeof AppLawVaultRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization/admin/': {
      id: '/_app/organization/admin/'
      path: '/'
      fullPath: '/organization/admin/'
      preLoaderRoute: typeof AppOrganizationAdminIndexRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/law/vault/': {
      id: '/_app/law/vault/'
      path: '/'
      fullPath: '/law/vault/'
      preLoaderRoute: typeof AppLawVaultIndexRouteImport
      parentRoute: typeof AppLawVaultRoute
    }
    '/_app/organization/admin/versions': {
      id: '/_app/organization/admin/versions'
      path: '/versions'
      fullPath: '/organization/admin/versions'
      preLoaderRoute: typeof AppOrganizationAdminVersionsRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/organization/admin/taxonomy': {
      id: '/_app/organization/admin/taxonomy'
      path: '/taxonomy'
      fullPath: '/organization/admin/taxonomy'
      preLoaderRoute: typeof AppOrganizationAdminTaxonomyRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/organization/admin/runs': {
      id: '/_app/organization/admin/runs'
      path: '/runs'
      fullPath: '/organization/admin/runs'
      preLoaderRoute: typeof AppOrganizationAdminRunsRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/organization/admin/risk': {
      id: '/_app/organization/admin/risk'
      path: '/risk'
      fullPath: '/organization/admin/risk'
      preLoaderRoute: typeof AppOrganizationAdminRiskRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/organization/admin/prompts': {
      id: '/_app/organization/admin/prompts'
      path: '/prompts'
      fullPath: '/organization/admin/prompts'
      preLoaderRoute: typeof AppOrganizationAdminPromptsRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/organization/admin/access': {
      id: '/_app/organization/admin/access'
      path: '/access'
      fullPath: '/organization/admin/access'
      preLoaderRoute: typeof AppOrganizationAdminAccessRouteImport
      parentRoute: typeof AppOrganizationAdminRoute
    }
    '/_app/law/vault/tasks': {
      id: '/_app/law/vault/tasks'
      path: '/tasks'
      fullPath: '/law/vault/tasks'
      preLoaderRoute: typeof AppLawVaultTasksRouteImport
      parentRoute: typeof AppLawVaultRoute
    }
    '/_app/law/vault/family/$familyId': {
      id: '/_app/law/vault/family/$familyId'
      path: '/family/$familyId'
      fullPath: '/law/vault/family/$familyId'
      preLoaderRoute: typeof AppLawVaultFamilyFamilyIdRouteImport
      parentRoute: typeof AppLawVaultRoute
    }
    '/_app/law/vault/analysis/$contractId': {
      id: '/_app/law/vault/analysis/$contractId'
      path: '/analysis/$contractId'
      fullPath: '/law/vault/analysis/$contractId'
      preLoaderRoute: typeof AppLawVaultAnalysisContractIdRouteImport
      parentRoute: typeof AppLawVaultRoute
    }
  }
}

interface AppOrganizationAdminRouteChildren {
  AppOrganizationAdminAccessRoute: typeof AppOrganizationAdminAccessRoute
  AppOrganizationAdminPromptsRoute: typeof AppOrganizationAdminPromptsRoute
  AppOrganizationAdminRiskRoute: typeof AppOrganizationAdminRiskRoute
  AppOrganizationAdminRunsRoute: typeof AppOrganizationAdminRunsRoute
  AppOrganizationAdminTaxonomyRoute: typeof AppOrganizationAdminTaxonomyRoute
  AppOrganizationAdminVersionsRoute: typeof AppOrganizationAdminVersionsRoute
  AppOrganizationAdminIndexRoute: typeof AppOrganizationAdminIndexRoute
}

const AppOrganizationAdminRouteChildren: AppOrganizationAdminRouteChildren = {
  AppOrganizationAdminAccessRoute: AppOrganizationAdminAccessRoute,
  AppOrganizationAdminPromptsRoute: AppOrganizationAdminPromptsRoute,
  AppOrganizationAdminRiskRoute: AppOrganizationAdminRiskRoute,
  AppOrganizationAdminRunsRoute: AppOrganizationAdminRunsRoute,
  AppOrganizationAdminTaxonomyRoute: AppOrganizationAdminTaxonomyRoute,
  AppOrganizationAdminVersionsRoute: AppOrganizationAdminVersionsRoute,
  AppOrganizationAdminIndexRoute: AppOrganizationAdminIndexRoute,
}

const AppOrganizationAdminRouteWithChildren =
  AppOrganizationAdminRoute._addFileChildren(AppOrganizationAdminRouteChildren)

interface AppOrganizationRouteChildren {
  AppOrganizationAdminRoute: typeof AppOrganizationAdminRouteWithChildren
  AppOrganizationCustomDashboardsRoute: typeof AppOrganizationCustomDashboardsRoute
  AppOrganizationOverviewRoute: typeof AppOrganizationOverviewRoute
  AppOrganizationPromptsRoute: typeof AppOrganizationPromptsRoute
  AppOrganizationReportsRoute: typeof AppOrganizationReportsRoute
  AppOrganizationTaxonomyRoute: typeof AppOrganizationTaxonomyRoute
  AppOrganizationUsersRoute: typeof AppOrganizationUsersRoute
  AppOrganizationVaultRoute: typeof AppOrganizationVaultRoute
  AppOrganizationIndexRoute: typeof AppOrganizationIndexRoute
}

const AppOrganizationRouteChildren: AppOrganizationRouteChildren = {
  AppOrganizationAdminRoute: AppOrganizationAdminRouteWithChildren,
  AppOrganizationCustomDashboardsRoute: AppOrganizationCustomDashboardsRoute,
  AppOrganizationOverviewRoute: AppOrganizationOverviewRoute,
  AppOrganizationPromptsRoute: AppOrganizationPromptsRoute,
  AppOrganizationReportsRoute: AppOrganizationReportsRoute,
  AppOrganizationTaxonomyRoute: AppOrganizationTaxonomyRoute,
  AppOrganizationUsersRoute: AppOrganizationUsersRoute,
  AppOrganizationVaultRoute: AppOrganizationVaultRoute,
  AppOrganizationIndexRoute: AppOrganizationIndexRoute,
}

const AppOrganizationRouteWithChildren = AppOrganizationRoute._addFileChildren(
  AppOrganizationRouteChildren,
)

interface AppTasksRouteChildren {
  AppTasksTaskUuidRoute: typeof AppTasksTaskUuidRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
}

const AppTasksRouteChildren: AppTasksRouteChildren = {
  AppTasksTaskUuidRoute: AppTasksTaskUuidRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
}

const AppTasksRouteWithChildren = AppTasksRoute._addFileChildren(
  AppTasksRouteChildren,
)

interface AppLawVaultRouteChildren {
  AppLawVaultTasksRoute: typeof AppLawVaultTasksRoute
  AppLawVaultIndexRoute: typeof AppLawVaultIndexRoute
  AppLawVaultAnalysisContractIdRoute: typeof AppLawVaultAnalysisContractIdRoute
  AppLawVaultFamilyFamilyIdRoute: typeof AppLawVaultFamilyFamilyIdRoute
}

const AppLawVaultRouteChildren: AppLawVaultRouteChildren = {
  AppLawVaultTasksRoute: AppLawVaultTasksRoute,
  AppLawVaultIndexRoute: AppLawVaultIndexRoute,
  AppLawVaultAnalysisContractIdRoute: AppLawVaultAnalysisContractIdRoute,
  AppLawVaultFamilyFamilyIdRoute: AppLawVaultFamilyFamilyIdRoute,
}

const AppLawVaultRouteWithChildren = AppLawVaultRoute._addFileChildren(
  AppLawVaultRouteChildren,
)

interface AppRouteChildren {
  AppOrganizationRoute: typeof AppOrganizationRouteWithChildren
  AppTasksRoute: typeof AppTasksRouteWithChildren
  AppUnauthorizedRoute: typeof AppUnauthorizedRoute
  AppLawVaultRoute: typeof AppLawVaultRouteWithChildren
  AppPlatformAccountRoute: typeof AppPlatformAccountRoute
  AppLawIndexRoute: typeof AppLawIndexRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOrganizationRoute: AppOrganizationRouteWithChildren,
  AppTasksRoute: AppTasksRouteWithChildren,
  AppUnauthorizedRoute: AppUnauthorizedRoute,
  AppLawVaultRoute: AppLawVaultRouteWithChildren,
  AppPlatformAccountRoute: AppPlatformAccountRoute,
  AppLawIndexRoute: AppLawIndexRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
